import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IContentAppealPreSubmissionProps } from "../../model/interface";
import { Label, Textarea } from "@fluentui/react-components";
import { JUSTIFICATION_MAX_LENGTH } from "../../constants/constants";
import Required from "../required/required";
import './ContentAppealPreSubmission.scss';

export default function ContentAppealPreSubmission(props: IContentAppealPreSubmissionProps) {
    const [justification, setJustification] = useState<string>("");
    const [hasEditedJustification, setHasEditedJustification] = useState<boolean>(false);
    const { t } = useTranslation();
    const displayedJustification = hasEditedJustification ? justification : props.currentFormInfo.appealerJustification;

    const handleJustificationChange = (justification: string) => {
        const newJustificaiton = justification;
        setHasEditedJustification(true);
        setJustification(newJustificaiton);
        props.justificationChange(newJustificaiton);
    }

    return (
        <div>
            <div className="form-overview">
                <h1 className="form-overview__header"> {t('Appeal.Common.submit-an-appeal')}</h1>
                <p className="form-overview__paragraph">{t('Appeal.Common.pre-submission-overview')}</p>
            </div>
            <div className="form-fields">
                <div className="justification-description">
                    <Label id="descriptionLabel">
                        {t('Appeal.Common.description')}
                        <span><Required /></span>
                    </Label>
                    <Textarea
                        id="appealerJustification"
                        aria-labelledby="descriptionLabel"
                        className="public-forms-justification"
                        data-testid="appealerJustification"
                        placeholder={displayedJustification ? undefined : t('Appeal.Common.description-placeholder')}
                        value={displayedJustification}
                        onChange={(e: any, data: { value: string; }) => handleJustificationChange(data.value)}
                        maxLength={JUSTIFICATION_MAX_LENGTH}
                        autoFocus
                    />
                </div>
            </div>
        </div>
    );
};